import React, { useEffect, useState } from "react";
import Axios from "../../axios/axios";

export default function Report() {
  const today = new Date().toISOString().split("T")[0];

  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);

  const [orders, setOrders] = useState([]);
  const [count, setCount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [filterType, setFilterType] = useState("all");

  useEffect(() => {
    getReport();
  }, []);

  const getReport = async () => {
    try {
      const res = await Axios.get(
        `/api/order/orderReport?from=${fromDate}&to=${toDate}`,
      );
      console.log("reportres", res);
      setOrders(res.data.orders);
      setCount(res.data.count);
      setTotalAmount(res.data.totalAmount);
      // console.log(
      //   "Orders received:",
      //   res.data.orders.map((o) => ({
      //     orderId: o.orderId,
      //     returnAt: o.orderItems?.[0]?.returnAt,
      //   })),
      // );
    } catch (error) {
      console.error(error);
    }
  };

  const getStatus = (order) => {
    // ✅ Cancelled first
    if (order.status === "cancelled") {
      return { text: "Admin Cancelled", class: "bg-danger" };
    }

    if (order.isRentOutInit) {
      return { text: "Rented Out", class: "bg-info" };
    }

    if (order.status === "approved") {
      return { text: "Order Placed", class: "bg-success" };
    }

    if (order.status === "pending") {
      return { text: "Pending Approval", class: "bg-warning text-dark" };
    }

    return { text: "Unknown", class: "bg-secondary" };
  };

  const getReturnStatus = (order) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const allReturned = order.orderItems.every((item) => item.isReturn);

    if (allReturned) {
      return {
        text: "Return Completed",
        class: "bg-success",
      };
    }

    const overdue = order.orderItems.some((item) => {
      const endDate = new Date(item.endDate);
      endDate.setHours(0, 0, 0, 0);

      return !item.isReturn && endDate < today;
    });

    if (overdue) {
      return {
        text: "Return Overdue",
        class: "bg-danger",
      };
    }

    return {
      text: "Return Pending",
      class: "bg-warning text-dark",
    };
  };
  const changeDate = (days) => {
    const current = new Date(fromDate);

    current.setDate(current.getDate() + days);

    const newDate = current.toISOString().split("T")[0];

    setFromDate(newDate);
    setToDate(newDate);
  };
  useEffect(() => {
    getReport();
  }, [fromDate, toDate]);
  const filteredOrders = orders.filter((order) => {
    if (filterType === "rented") {
      return order.isRentOutInit && order.status !== "cancelled";
    }

    if (filterType === "placed") {
      const placedDate = new Date(order.createdAt).toISOString().split("T")[0];
      return placedDate >= fromDate && placedDate <= toDate;
    }

    if (filterType === "startDate") {
      return order.orderItems.some((item) => {
        const start = item.startDate?.split("T")[0];
        return start >= fromDate && start <= toDate;
      });
    }
    if (filterType === "returnDate") {
      return order.orderItems.some((item) => {
        // Actual returned date
        if (item.returnAt) {
          const returnDate = item.returnAt;

          if (returnDate >= fromDate && returnDate <= toDate) {
            return true;
          }
        }

        // Scheduled return date
        if (item.endDate) {
          const endDate = item.endDate;

          if (endDate >= fromDate && endDate <= toDate) {
            return true;
          }
        }

        return false;
      });
    }
    return true;
  });
  return (
    <div className="container-fluid">
      <div className="d-flex gap-2 mb-3">
        {/* ALL */}
        <button
          className={`btn mb-2 ${
            filterType === "all" ? "btn-primary" : "btn-outline-primary"
          }`}
          onClick={() => setFilterType("all")}
        >
          All Orders
        </button>
        {/* PLACED */}
        <button
          className={`btn mb-2 ${
            filterType === "placed" ? "btn-primary" : "btn-outline-primary"
          }`}
          onClick={() => setFilterType("placed")}
        >
          Order Place Date
        </button>
        {/* PLACED */}
        <button
          className={`btn mb-2 ${
            filterType === "startDate" ? "btn-primary" : "btn-outline-primary"
          }`}
          onClick={() => setFilterType("startDate")}
        >
          Order Start Date
        </button>
        {/* RENTED */}
        <button
          className={`btn mb-2 ${
            filterType === "rented" ? "btn-primary" : "btn-outline-primary"
          }`}
          onClick={() => setFilterType("rented")}
        >
          Rented Only
        </button>
        <button
          className={`btn mb-2 ${
            filterType === "returnDate" ? "btn-primary" : "btn-outline-primary"
          }`}
          onClick={() => setFilterType("returnDate")}
        >
          Order Return Date
        </button>
      </div>
      {/* Date Filters */}
      <div className="card mb-3">
        <div className="card-body d-flex align-items-end gap-3 flex-wrap">
          <div>
            <label>From</label>
            <input
              type="date"
              className="form-control"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>

          <div>
            <label>To</label>
            <input
              type="date"
              className="form-control"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>

          <button
            className="btn btn-outline-secondary"
            onClick={() => changeDate(-1)}
          >
            ⬅️ Prev
          </button>

          <button
            className="btn btn-outline-primary"
            onClick={() => {
              setFromDate(today);
              setToDate(today);
            }}
            disabled={fromDate === today}
          >
            📅 Today
          </button>

          <button
            className="btn btn-outline-secondary"
            onClick={() => changeDate(1)}
          >
            Next ➡️
          </button>

          <button className="btn btn-primary" onClick={getReport}>
            Filter
          </button>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="row mb-4">
        <div className="col-md-3">
          <div className="card text-white bg-primary mb-2">
            <div className="card-body">
              <h6>Total Orders</h6>
              <h3>{filteredOrders.length}</h3>
            </div>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card text-white bg-success">
            <div className="card-body">
              <h6>Total Amount</h6>
              <h3>
                ₹{" "}
                {filteredOrders.reduce(
                  (sum, order) => sum + Number(order.orderAmount || 0),
                  0,
                )}
              </h3>
            </div>
          </div>
        </div>
      </div>

      {/* Order Table */}
      <div className="card">
        <div className="card-body">
          <h4 className="card-title">Order Details</h4>

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Order ID</th>
                  <th>Customer</th>
                  <th>Phone</th>
                  <th>Amount</th>
                  <th>Order Placed Date</th>
                  <th>Order Start Date</th>
                  <th>End Date</th>
                  {filterType === "returnDate" && <th>Returned Date </th>}
                  <th>Order Status</th>
                  {filterType === "returnDate" && <th>Return Status</th>}
                </tr>
              </thead>

              <tbody>
                {filteredOrders.length > 0 ? (
                  filteredOrders.map((order, index) => (
                    <tr key={order._id}>
                      <td>{index + 1}</td>
                      <td>ADC_{order.orderId}</td>
                      <td>{order.user?.name}</td>
                      <td>{order.user?.phone}</td>
                      <td>₹ {order.orderAmount}</td>
                      <td>{new Date(order.createdAt).toLocaleDateString()}</td>
                      <td>
                        {[
                          ...new Set(
                            order.orderItems.map((item) => item.startDate),
                          ),
                        ].map((date, i) => (
                          <div key={i}>
                            {new Date(date).toLocaleDateString()}
                          </div>
                        ))}
                      </td>

                      <td>
                        {[
                          ...new Set(
                            order.orderItems.map((item) => item.endDate),
                          ),
                        ].map((date, i) => (
                          <div key={i}>
                            {new Date(date).toLocaleDateString()}
                          </div>
                        ))}
                      </td>
                      {filterType === "returnDate" && (
                        <td>
                          {order.orderItems.some((item) => item.returnAt)
                            ? [
                                ...new Set(
                                  order.orderItems
                                    .filter((item) => item.returnAt)
                                    .map((item) => item.returnAt),
                                ),
                              ].map((date, i) => (
                                <div key={i}>
                                  {new Date(date).toLocaleDateString()}
                                </div>
                              ))
                            : "-"}
                        </td>
                      )}
                      <td>
                        <span className={`badge ${getStatus(order).class}`}>
                          {getStatus(order).text}
                        </span>
                      </td>
                      {filterType === "returnDate" && (
                        <td>
                          <span
                            className={`badge ${getReturnStatus(order).class}`}
                          >
                            {getReturnStatus(order).text}
                          </span>
                        </td>
                      )}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No orders found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
